import React, { Component } from "react";
import { message, Spin, Typography, Alert } from "antd";
import { PoweroffOutlined, LogoutOutlined } from "@ant-design/icons";
import axios from "axios";
import {
  ModalItem,
  InputItem,
  ButtonItem,
} from "../../../../Components/Items";

const { Text } = Typography;

class ModalCerrarSesiones extends Component {
  state = {
    loading: false,
    textoConfirmacion: "",
  };

  componentDidUpdate(prevProps) {
    if (this.props.visible && !prevProps.visible) {
      this.setState({ textoConfirmacion: "" });
    }
  }

  handleCerrar = async () => {
    const { tipo, sessionId } = this.props;

    this.setState({ loading: true });
    try {
      const url =
        tipo === "todas"
          ? "sesiones/cerrarTodasSesiones"
          : "sesiones/cerrarSesion";
      const body = tipo === "todas" ? {} : { sessionId };

      const res = await axios.post(url, body, {
        headers: this.props.headersToken,
      });

      if (res.data.success === 1) {
        if (tipo === "todas") {
          message.success(`Se cerraron ${res.data.eliminadas || 0} sesiones`);
        } else {
          message.success("Sesión cerrada");
        }
        this.props.onSuccess(tipo);
      } else {
        message.error(res.data.message || "Error al cerrar la sesión");
      }
    } catch (error) {
      console.error(error);
      message.error("Ocurrió un error de conexión al cerrar la sesión.");
    } finally {
      this.setState({ loading: false });
    }
  };

  render() {
    const { visible, onCancel, tipo } = this.props;
    const { textoConfirmacion, loading } = this.state;

    const esTodas = tipo === "todas";
    const puedeCerrar = esTodas ? textoConfirmacion === "Cerrar" : true;

    return (
      <ModalItem
        title={esTodas ? "Cerrar todas las sesiones" : "Cerrar sesión"}
        visible={visible}
        onCancel={onCancel}
        spinning={false}
        width={450}
      >
        <Spin spinning={loading}>
          {esTodas ? (
            <>
              <Alert
                message="¡Advertencia!"
                description="Esta acción cerrará todas las sesiones activas excepto la tuya. Los demás usuarios serán desconectados."
                type="error"
                showIcon
                style={{ marginBottom: 20 }}
              />

              <div style={{ marginBottom: 15 }}>
                <Text>
                  Para confirmar, por favor escribe la palabra{" "}
                  <strong style={{ color: "#ff4d4f" }}>Cerrar</strong> en el
                  siguiente recuadro:
                </Text>
              </div>

              <InputItem
                placeholder="Escribe Cerrar"
                value={textoConfirmacion}
                onChange={(e) =>
                  this.setState({ textoConfirmacion: e.target.value })
                }
                autoComplete="off"
                style={{ marginBottom: 10 }}
              />
            </>
          ) : (
            <div style={{ padding: "10px 0 0px", textAlign: "center" }}>
              <h3 style={{ margin: 0 }}>¿Deseas cerrar esta sesión?</h3>
              <p style={{ color: "#666", marginTop: 8 }}>
                El usuario será desconectado en su siguiente acción.
              </p>
            </div>
          )}

          <ButtonItem
            type="primary"
            danger
            icon={esTodas ? <PoweroffOutlined /> : <LogoutOutlined />}
            onClick={this.handleCerrar}
            disabled={!puedeCerrar}
            style={{ width: "100%", marginTop: 5, marginBottom: 5 }}
          >
            {esTodas ? "Sí, cerrar todas las sesiones" : "Sí, cerrar sesión"}
          </ButtonItem>
        </Spin>
      </ModalItem>
    );
  }
}

export default ModalCerrarSesiones;
